import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SportsIllustratedAuthService } from '../sports-illustrated-service/sports-illustrated-auth.service';

@Component({
  selector: 'fgb-sports-illustrated-callback',
  templateUrl: './sports-illustrated-callback.component.html',
  styleUrls: ['./sports-illustrated-callback.component.scss'],
})
export class SportsIllustratedCallbackComponent implements OnInit {
  cookieName: string = '_si_sso_upid';
  constructor(
    private sportsIllustratedService: SportsIllustratedAuthService,
    private router: Router,
    private cookie: CookieService
  ) {}

  ngOnInit() {

    let code = this.getParameter('code');
    let codeVerifier = this.cookie.get('si-codeverifier');
    let state = this.getParameter('state');

    this.sportsIllustratedService
      .validateCallBack(code, codeVerifier, state)
      .catch(() => {
        console.log('ERROR : unable to validate customer');
        this.router.navigate(['/login']);
      });
  }

  getParameter(name: string) : string {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if(!results){
      return '';
    }
    return results[1] as (string) || '';
  }
}
